export enum AppRoute {
  Home = "/",
  Documents = "/documents",
  DocumentsDeepLink = "/documents/:batchId/:documentId",
  FundDocumentsDeepLink = "/fund-profile/:entityID/:batchId/:documentId",
  MyProfile = "/my-profile",
  UserProfile = "/profile",
  DataRooms = "/data-rooms",
  DataRoomDocumentsDeepLink = "/data-rooms/:globalId/:batchId/:documentId",
  DataRoomVideoDeepLink = "/data-rooms/:globalId/video/:videoId",
  DataRoom = "/data-rooms/:globalId",
  FundProfile = "/fund-profile/:entityID",
  AccountSummaryCarlyle = "/reporting/account-summary/carlyle",
  AccountSummaryAlpInvest = "/reporting/account-summary/alpinvest",
  ReportingBase = "/reporting",
  CapitalAccountStatement = "/reporting/capital-account-statement",
  ScheduleOfInvestments = "/reporting/schedule-of-investments",
  CashFlowActivity = "/reporting/cash-flow-activity",
  PortfolioPerformance = "/reporting/portfolio-performance",
  DiversificationAnalysis = "/reporting/diversification-analysis",
  AdministrationBase = "/administration",
  AdministrationReports = "/administration/reports",
  AdministrationImpersonate = "/administration/impersonate",
  InsightsHub = "/content-library",
  InsightsHubArticle = "/content-library/:articleId",
  MyCalendar = "/my-calendar",
  MyCalendarEventDocumentDeepLink = "/my-calendar/:eventId/:batchId/:documentId",
  MyCalendarEventVideoDeepLink = "/my-calendar/:eventId/video/:videoId",
  MyCalendarEvent = "/my-calendar/:eventId",
  ManageContacts = "/manage-contacts",
  Help = "/help",
  Login = "/login",
  SignOut = "/signout",
}
